var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobotUnregistrationModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4534_13081)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4534_13081",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 74
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00292969H73.5683V73.5713H0V0.00292969Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4534_13081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2293 5.37342C42.2293 8.33946 39.8247 10.7439 36.8588 10.7439C33.8928 10.7439 31.4883 8.33946 31.4883 5.37342C31.4883 2.40738 33.8928 0.00292969 36.8588 0.00292969C39.8247 0.00292969 42.2293 2.40738 42.2293 5.37342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8577 10.7427H27.6617C19.5901 10.7427 12.7426 15.9843 10.3374 23.2493H10.0053C4.47952 23.2493 0 27.7289 0 33.2546C0 38.7803 4.47952 43.2599 10.0053 43.2599H10.2428C12.5586 50.6772 19.4815 56.0608 27.6617 56.0608H46.0538C54.234 56.0608 61.1569 50.6772 63.4727 43.2599H63.563C69.0888 43.2599 73.5683 38.7803 73.5683 33.2546C73.5683 27.7289 69.0888 23.2493 63.563 23.2493H63.3781C60.9729 15.9843 54.1254 10.7427 46.0538 10.7427H36.8577ZM54.6886 32.0775C54.6886 35.8496 51.6306 38.9077 47.8583 38.9077C44.086 38.9077 41.028 35.8496 41.028 32.0775C41.028 28.3052 44.086 25.2471 47.8583 25.2471C51.6306 25.2471 54.6886 28.3052 54.6886 32.0775ZM25.6637 38.9077C29.436 38.9077 32.4941 35.8496 32.4941 32.0775C32.4941 28.3052 29.436 25.2471 25.6637 25.2471C21.8916 25.2471 18.8335 28.3052 18.8335 32.0775C18.8335 35.8496 21.8916 38.9077 25.6637 38.9077Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2305 73.5683C17.6384 65.0054 26.5645 59.1489 36.8585 59.1489C47.1524 59.1489 56.0785 65.0054 60.4864 73.5683H13.2305Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4534_13081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.5683,
    height: 73.5683,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotUnregistrationModalIcon);
export default __webpack_public_path__ + "static/media/robot-unregistration-modal-icon.55e7bd783e67c0d51c465d7b978f8bcd.svg";
export { ForwardRef as ReactComponent };